/* eslint-disable no-console */
<template>
    <div>
        <div class="header_unit header_bg_white">
            <div class="header_box">
                <div class="menu_left">
                    <router-link class="icn_back_black top_tit" :to="{ name: 'manageCheckMenuList'} ">
                        <p class="top_tit">＜戻る</p></router-link>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_l top_tit">チェック内容設定編集画面</p>
                </div>
            </div>
        </div>
        <CheckViewSetting/>
    </div>

</template>

<script>
    import CheckViewSetting from '@/app/components/CheckViewSetting.vue'
    export default {
        name: 'manageCheckViewSetting',
        components: {
            CheckViewSetting
        }
    }
</script>
